import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

export const getAllArticles = async (params = {}) => {
  const response = await apiFetch(`/api/wiki/articles${buildQuery(params)}`);
  return parseApiResponse(response);
};

export const searchArticles = async (params = {}) => {
  const response = await apiFetch(`/api/wiki/search${buildQuery(params)}`);
  return parseApiResponse(response);
};

export const getArticleById = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}`);
  return parseApiResponse(response);
};

export const createArticle = async (articleData) => {
  const response = await apiFetch('/api/wiki/articles', {
    method: 'POST',
    body: JSON.stringify(articleData),
  });
  return parseApiResponse(response);
};

export const updateArticle = async (id, articleData) => {
  const response = await apiFetch(`/api/wiki/articles/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(articleData),
  });
  return parseApiResponse(response);
};

export const autosaveWikiArticle = async (id, articleData) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/autosave`, {
    method: 'PATCH',
    body: JSON.stringify(articleData),
  });
  return parseApiResponse(response);
};

export const deleteArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    await parseApiResponse(response);
  }
};

export const publishArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/publish`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const submitArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/submit`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const requestArticleRevision = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/revise`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const archiveArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/archive`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const restoreArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/restore`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const getWikiCategories = async (params = {}) => {
  const response = await apiFetch(`/api/wiki/categories${buildQuery(params)}`);
  return parseApiResponse(response);
};

export const createWikiCategory = async (categoryData) => {
  const response = await apiFetch('/api/wiki/categories', {
    method: 'POST',
    body: JSON.stringify(categoryData),
  });
  return parseApiResponse(response);
};

export const updateWikiCategory = async (id, categoryData) => {
  const response = await apiFetch(`/api/wiki/categories/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(categoryData),
  });
  return parseApiResponse(response);
};

export const getWikiArticleTypes = async () => {
  const response = await apiFetch('/api/wiki/types');
  return parseApiResponse(response);
};

export const getFavoriteArticleIds = async () => {
  const response = await apiFetch('/api/wiki/favorites');
  return parseApiResponse(response);
};

export const addFavoriteArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/favorite`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const removeFavoriteArticle = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/favorite`, {
    method: 'DELETE',
  });
  return parseApiResponse(response);
};

export const recordArticleView = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/view`, {
    method: 'POST',
  });
  return parseApiResponse(response);
};

export const getRecentArticleIds = async () => {
  const response = await apiFetch('/api/wiki/recent');
  return parseApiResponse(response);
};

export const getWikiViewStats = async () => {
  const response = await apiFetch('/api/wiki/stats/views');
  return parseApiResponse(response);
};

export const getArticleRevisions = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/revisions`);
  return parseApiResponse(response);
};

export const getArticleRevision = async (articleId, revisionId) => {
  const response = await apiFetch(`/api/wiki/articles/${articleId}/revisions/${revisionId}`);
  return parseApiResponse(response);
};

export const getArticleComments = async (id) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/comments`);
  return parseApiResponse(response);
};

export const createArticleComment = async (id, commentData) => {
  const response = await apiFetch(`/api/wiki/articles/${id}/comments`, {
    method: 'POST',
    body: JSON.stringify(commentData),
  });
  return parseApiResponse(response);
};

export const updateArticleComment = async (articleId, commentId, commentData) => {
  const response = await apiFetch(`/api/wiki/articles/${articleId}/comments/${commentId}`, {
    method: 'PATCH',
    body: JSON.stringify(commentData),
  });
  return parseApiResponse(response);
};
